module.exports = __webpack_public_path__ + "static/Laser-7e54828dab26c532a77afbf5021e0115.jpg";